import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox, Input } from 'antd';
import PageElementTypeEnum from 'enums/page_element_type.enum';
import ElementActions from 'pages/admin/common/page-elements/types/ElementActions';
import AddImageButton from 'components/AddImageButton';

const ImageElement = React.memo(({ id, pageElement, setPageElement, setRefs }) => {
    const { t } = useTranslation();
    const [fileList, setFileList] = useState(pageElement.image_media_url ? [pageElement.image_media_url] : []);

    const onFileListChange = fileList => {
        setPageElement({ id, changes: { image_media_url: fileList.length > 0 ? fileList[0] : null, media_url: null } });
    };

    return (
        <div className="page-element-block">
            <div className="header pb-24">
                <div className="element-common-heading">{t(`enum:${PageElementTypeEnum.IMAGE.text}`)}</div>
                <ElementActions id={id} />
            </div>
            <div className="element-item">
                <AddImageButton
                    className="d-flex mb-24"
                    fileList={fileList}
                    setFileList={setFileList}
                    onChange={onFileListChange}
                />
                <div className="element-item-label">{'キャプション'}</div>
                <Input
                    value={pageElement.content}
                    onChange={e => {
                        setPageElement({ id, changes: { content: e.target.value } });
                    }}
                    ref={el => setRefs({ id, el: el })}
                />
            </div>
            <div>
                <Checkbox
                    className="mt-24"
                    checked={pageElement.is_displayed}
                    onChange={e => {
                        setPageElement({ id, changes: { is_displayed: e.target.checked ? 1 : 0 }});
                    }}
                >
                    {t('Posted in the news')}
                </Checkbox>
            </div>
        </div>
    );
});

export default ImageElement;

ImageElement.propTypes = {
    id: PropTypes.any.isRequired,
    pageElement: PropTypes.object,
    setPageElement: PropTypes.func,
};
